import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonContent, IonList, IonItem, IonInfiniteScroll, IonInfiniteScrollContent, IonHeader, IonFooter } from '@ionic/react';
import ReactDOM from 'react-dom';


import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { EnterPasswordModal } from './Modal_EnterPassword';
import { InvoiceDetailsModal_Project } from './Modal_InvoiceDetails_project';

//import classes from './Modal_ViewModal.module.css';
import '../../../../css/qavaApp.css';

const Backdrop = props => {
    return <div className='backdrop'/>
};

export function ViewInvoiceModal_Projects (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);


    let [showPasswordModal, setShowPasswordModal] = useState(false);

    let [viewExpenses, setViewExpenses] = useState([]);

    let [customerInvoiceID, setCustomerInvoiceID] = useState(null);
    let [supplierName, setSupplierName] = useState(null);
    let [supplierPhoneNumber, setSupplierPhoneNumber] = useState(null);

    let [showInvoiceDetailsModal, setShowInvoiceDetailsModal] = useState(false);

    let [invoiceID, setInvoiceID] = useState(false);

    let [deletTracker, setDeleteTracker] = useState(null);


    useEffect(() => {

            /*
            let formData = new FormData();
            formData.append('Tracker', '74002A');
            formData.append('user', acctID);
            formData.append('xStartDateRange', props.startDate.toISOString().substr(0, 10));
            formData.append('xEndDateRange', props.endDate.toISOString().substr(0, 10));
                

            const requestOptions = {
                enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
            */

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74002A_view_project_invoices',
                    user: acctID,
                    xProjectID: props.data.projectID,
                    sessionID: sessionID,
    
                }),
            }
            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');
                    
                    setViewExpenses((prevAvailableRooms) => {
                        return prevAvailableRooms.concat({
                            invoiceID: cols[0],
                            customerInvoiceID: cols[11],
                            supplierName: cols[4],
                            supplierPhoneNumber: cols[19],
                            invoiceDescription: cols[20],
                            dateLogged: new Date(cols[2]).toISOString().substr(0, 10),
                            //unitAmount: parseFloat(cols[5]).toFixed(2),
                            //quantity: cols[6],
                            totalAmount: parseFloat(cols[5]).toFixed(2),
                            //paymentType: cols[8],
                            attachment: cols[3],
                        })
                    });
                } 
            })
    }, []);

    function deleteInvoiceProjects(enteredPassword)
    {

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: deletTracker,
                user: acctID,
                xInvoiceID: invoiceID,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function closeModalHandler(event) {

        setViewExpenses([]);
        props.closeModal(event);
    }
 
    function viewExpenseDetailsHandler(event) {

        setInvoiceID(event[1]);
        setCustomerInvoiceID(event[2]);
        setSupplierName(event[3]);
        setSupplierPhoneNumber(event[4]);

        setShowInvoiceDetailsModal(event[0]);

        //setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
    }

    function viewDeleteExpenseHandler(event) {


        setShowPasswordModal(event[0]);
        setInvoiceID(event[1]);
        setCustomerInvoiceID(event[2]);
        setDeleteTracker(event[3])

    }

    function onSubmitPasswordHandler(event)
    {
        deleteInvoiceProjects(event);
    }


    return (

        <React.Fragment> 

                        <IonGrid className='appGridContent'>
                            <IonRow >
                                    <IonCol size='3'> <h3> Supplier Name </h3> </IonCol>
                                    {/*<IonCol className='appGridCol' size='2'> <h3> Supplier Phone </h3> </IonCol>*/}
                                    {/*<IonCol className='appGridCol' size='3'> <h3> Expense Description </h3> </IonCol>*/}
                                    <IonCol size='3'> <h3> Date Logged </h3> </IonCol>
                                    <IonCol size='3'> <h3> Total Amount </h3> </IonCol>                                        
                                    <IonCol size='3'> <h3> Action </h3> </IonCol>
                            </IonRow>
                        {viewExpenses.map((detailData) =>   {
                            return (
                                    <IonRow key={detailData.invoiceID}>
                                        <IonCol size='3'>{detailData.supplierName}</IonCol>
                                        {/*<IonCol className='appGridCol' size='2'>{detailData.supplierPhoneNumber}</IonCol>*/}
                                        {/*<IonCol className='appGridCol' size='3'>{detailData.expenseDescription}</IonCol>*/}
                                        <IonCol size='3'>{detailData.dateLogged}</IonCol>
                                        <IonCol size='3'>{detailData.totalAmount}</IonCol>
                                        <IonCol size='3'>

                                            <IonButton className='appListButton' onClick={() => viewExpenseDetailsHandler([true, detailData.invoiceID, detailData.customerInvoiceID, detailData.supplierName, detailData.supplierPhoneNumber])}> Details </IonButton>
                                            {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton className='appListButton' onClick={() => viewDeleteExpenseHandler([true, detailData.invoiceID, detailData.customerInvoiceID, '74002D_delete_invoice_project_hard'])}> H-Delete </IonButton>}
                                            {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton className='appListButton' onClick={() => viewDeleteExpenseHandler([true, detailData.invoiceID, detailData.customerInvoiceID, '74002D_delete_invoice_project_soft'])}> S-Delete </IonButton>}
                                    
                                        </IonCol>
                                    </IonRow>
                            )
                        }
                        )}
                        </IonGrid>

                        <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>

                        <InvoiceDetailsModal_Project openModal={ showInvoiceDetailsModal } closeModal={() => setShowInvoiceDetailsModal(false)} data={{
                                            projectID: props.data.projectID, 
                                            invoiceID: invoiceID, 
                                            customerInvoiceID: customerInvoiceID,
                                            estimates: props.data.estimates, 
                                            expenseID: props.data.expenses, 
                                            supplier_name: supplierName,
                                            supplier_phoneNumber: supplierPhoneNumber,
                                            }}></InvoiceDetailsModal_Project>


        </React.Fragment>

    )
}